export default __webpack_public_path__ + "8f2c4f27c5b79ce942c4afc4e1f32806.svg";